import { useTheme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Edit from "@material-ui/icons/Edit";
import Button from "@material-ui/core/Button";
import { useEffect, useState } from "react";
import { useStyles } from "./styles";
import SettingsCard from "components/PhotoAdminComponents/Settings/Card/SettingsCard";
import ActionButton from "components/common/ActionButton/ActionButton";
import { Form, Formik } from "formik";
import { useRef } from "react";
import nameChangeValidationSchema from "validation/UserSettings/NameChangeSchema";
import { CircularProgress } from "@material-ui/core";
import vatNumberChangeValidationSchema from "validation/UserSettings/VatNumberChangeValidationSchema";

const ChangeVatNumberCard = ({ user, putUserVatNumber, inProgress }) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const [isEditing, setIsEditing] = useState(false);
  const toggleIsEditing = () => setIsEditing(!isEditing);
  const formikRef = useRef(null);

  const [vatNumberData, setVatNumberData] = useState({ vatNumber: "" });

  useEffect(() => {
    if (user && formikRef.current) {
      formikRef.current.values.vatNumber = vatNumberData?.vatNumber;
    }
  }, [user, formikRef]);

  useEffect(() => {
    if (isEditing) {
      setVatNumberData({ vatNumber: "" });
    } else {
      setVatNumberData({
        vatNumber: user?.billingInfo?.vatNumber,
      });
    }
  }, [user, isEditing]);

  return (
    <SettingsCard
      title={"Adószám"}
      actionButton={
        <ActionButton
          icon={<Edit color="primary" />}
          clickHandler={toggleIsEditing}
        />
      }
    >
      <Formik
        innerRef={formikRef}
        enableReinitialize
        initialValues={{
          vatNumber: "",
        }}
        validationSchema={vatNumberChangeValidationSchema}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          setSubmitting(true);

          await putUserVatNumber({
            ...user,
            billingInfo: {
              ...user?.billingInfo,
              vatNumber: values.vatNumber,
            },
          });
          setIsEditing(false);
          setSubmitting(false);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          resetForm,
        }) => (
          <Form style={{ width: "100%" }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  disabled={!isEditing}
                  variant="outlined"
                  fullWidth
                  required
                  label={"Adószám"}
                  id="vatNumber"
                  name="vatNumber"
                  value={
                    isEditing ? values.vatNumber : vatNumberData?.vatNumber
                  }
                  onChange={handleChange}
                  error={touched.vatNumber && Boolean(errors.vatNumber)}
                  helperText={touched.vatNumber && errors.vatNumber}
                />
              </Grid>{" "}
            </Grid>
            <Grid
              item
              container
              style={{
                margin: "2rem 0 0 0",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
              }}
            >
              <Grid item xs={12}>
                <Button
                  disabled={!isEditing}
                  type="submit"
                  fullWidth
                  onClick={handleSubmit}
                  variant="outlined"
                  className={classes.button}
                >
                  {inProgress === "vatNumber" ? (
                    <>
                      Folyamatban
                      <CircularProgress
                        style={{ marginLeft: "0.5rem" }}
                        size={24}
                      />
                    </>
                  ) : (
                    "Adószám frissítése"
                  )}
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </SettingsCard>
  );
};

export default ChangeVatNumberCard;
